/* assets/video-defer.js  —  Deferred video loader (click-to-play)
   - Supports:
     • data-video-src (legacy single source)
     • data-video-src-mp4 / data-video-src-webm
     • data-loop="true|false"
     • data-muted="true|false" (default true)
     • data-playsinline="true|false" (default true)
     • data-controls="true|false" (default false)
     • data-autoplay="true|false" (kept click-gated for performance)
     • Optional background cover styling via CSS (see notes)
   - Expected HTML children:
     • .deferred-video__poster  (img or picture)
     • .deferred-video__play    (button)
     • .deferred-video__mount   (empty div where <video> is injected)
*/

(function () {
  if (window.__deferredVideoInit) return; // guard against double-including
  window.__deferredVideoInit = true;

  var WRAPPER_SEL = ".deferred-video, .deferred-bg-video";
  var PLAY_BTN_SEL = ".deferred-video__play";
  var POSTER_SEL = ".deferred-video__poster";
  var MOUNT_SEL = ".deferred-video__mount";

  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function strBool(val, defTrue) {
    if (val == null) return !!defTrue;
    var s = String(val).toLowerCase().trim();
    if (s === "true" || s === "1" || s === "") return true;
    if (s === "false" || s === "0") return false;
    return !!defTrue;
  }

  function getSources(wrapper) {
    // Backward-compatible: prefer explicit sources; fall back to legacy single src
    var srcMp4 = wrapper.getAttribute("data-video-src-mp4");
    var srcWebm = wrapper.getAttribute("data-video-src-webm");
    var legacy = wrapper.getAttribute("data-video-src"); // legacy single
    return {
      mp4: srcMp4 || (/\.mp4(\?|$)/i.test(legacy || "") ? legacy : ""),
      webm: srcWebm || (/\.webm(\?|$)/i.test(legacy || "") ? legacy : "")
    };
  }

  function mountVideo(wrapper) {
    if (!wrapper || wrapper.dataset.loaded === "1") return;

    var mount = q(MOUNT_SEL, wrapper);
    if (!mount) return;

    var sources = getSources(wrapper);
    if (!sources.mp4 && !sources.webm) return;

    var loop = strBool(wrapper.getAttribute("data-loop"), false);
    var muted = strBool(wrapper.getAttribute("data-muted"), true);
    var playsinline = strBool(wrapper.getAttribute("data-playsinline"), true);
    var controls = strBool(wrapper.getAttribute("data-controls"), false);
    // We still only start after user intent to protect performance.
    var autoplayFlag = strBool(wrapper.getAttribute("data-autoplay"), false);

    // Build <video>
    var video = document.createElement("video");
    video.classList.add("defer-exempt");
    video.preload = "none";
    if (playsinline) { video.setAttribute("playsinline",""); video.setAttribute("webkit-playsinline",""); }
    video.muted = muted;
if (muted) video.setAttribute("muted", ""); // iOS needs the attribute
    video.loop = loop;
    if (controls) video.controls = true;

    // Sources (prefer webm first if present)
    if (sources.webm) {
      var s1 = document.createElement("source");
      s1.src = sources.webm;
      s1.type = "video/webm";
      video.appendChild(s1);
    }
    if (sources.mp4) {
      var s2 = document.createElement("source");
      s2.src = sources.mp4;
      s2.type = "video/mp4";
      video.appendChild(s2);
    }

    // Use poster src if present
    var posterEl = q(POSTER_SEL, wrapper);
    if (posterEl && posterEl.getAttribute && posterEl.getAttribute("src")) {
      video.setAttribute("poster", posterEl.getAttribute("src"));
    }

    // Swap UI
    if (posterEl) posterEl.style.display = "none";
    var playBtn = q(PLAY_BTN_SEL, wrapper);
    if (playBtn) playBtn.style.display = "none";
    mount.replaceChildren(video);

    wrapper.dataset.loaded = "1";
    wrapper.classList.add("is-mounted");
wrapper.classList.add("is-playing");

    // Autoplay after intent (click/keyboard). If data-autoplay="true" we still
    // respect user gesture policy by starting now (we're in the click handler).
    video.play().catch(function(){ /* ignore blocked autoplay */ });

    // Dispatch a custom event for analytics hooks
    try {
      wrapper.dispatchEvent(new CustomEvent("deferredvideo:mounted", { detail: { video: video } }));
    } catch (e) {}
  }

  function onWrapperClick(e) {
    var btn = e.target.closest(PLAY_BTN_SEL);
    var wrapper = btn ? btn.closest(WRAPPER_SEL) : e.target.closest(WRAPPER_SEL);
    if (!wrapper) return;
    if (wrapper.dataset.loaded === "1") return; // already mounted
    e.preventDefault();
    e.stopPropagation();
    mountVideo(wrapper);
  }

  function onWrapperKeydown(e) {
    // Space/Enter to play when focused inside wrapper
    if (e.key !== " " && e.key !== "Enter" && e.keyCode !== 32 && e.keyCode !== 13) return;
    var wrapper = e.target.closest && e.target.closest(WRAPPER_SEL);
    if (!wrapper || wrapper.dataset.loaded === "1") return;
    e.preventDefault();
    mountVideo(wrapper);
  }

  function prepareWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.prepared === "1") return;

    // Set proper roles for accessibility
    var playBtn = q(PLAY_BTN_SEL, wrapper);
    if (playBtn) {
      playBtn.setAttribute("type", "button");
      playBtn.setAttribute("aria-label", playBtn.getAttribute("aria-label") || "Play video");
    }

    // Ensure mount node exists
    if (!q(MOUNT_SEL, wrapper)) {
      var m = document.createElement("div");
      m.className = "deferred-video__mount";
      wrapper.appendChild(m);
    }

    // Optional: Hover-to-play (opt-in via .hover-play class)
    if (wrapper.classList.contains("hover-play")) {
      wrapper.addEventListener("mouseenter", function () {
        if (wrapper.dataset.loaded === "1") return;
        mountVideo(wrapper);
      });
    }

    wrapper.dataset.prepared = "1";
  }

  function initExisting() {
    qa(WRAPPER_SEL).forEach(prepareWrapper);
  }

  // Mutation Observer to catch wrappers added later
  var mo;
  function watchMutations() {
    if (!("MutationObserver" in window)) return;
    mo = new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        qa(WRAPPER_SEL, m.target).forEach(prepareWrapper);
        qa(WRAPPER_SEL, document).forEach(function (w) {
          // no-op; preparation is idempotent
        });
      });
    });
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
  }

  function bindGlobalHandlers() {
  function delegate(e) {
    var inWrapper = e.target.closest && e.target.closest(WRAPPER_SEL);
    if (!inWrapper) return;
    onWrapperClick(e);
  }

  // Start faster on touch while keeping click as fallback
  document.addEventListener("pointerdown", delegate, true);
  document.addEventListener("click", delegate, true);
  document.addEventListener("keydown", onWrapperKeydown, true);
}

  function init() {
    initExisting();
    watchMutations();
    bindGlobalHandlers();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

